import React from "react";

const COLORS = {
  // Lead
  "New Lead": "bg-blue-50 text-blue-700 ring-1 ring-blue-200",
  "Contacted": "bg-violet-50 text-violet-700 ring-1 ring-violet-200",
  "Quoted": "bg-amber-50 text-amber-800 ring-1 ring-amber-200",
  "Awaiting Customer Confirmation": "bg-orange-50 text-orange-800 ring-1 ring-orange-200",
  "Confirmed": "bg-[#E8F5E0] text-[#3F7A1F] ring-1 ring-[#B9DDA4]",
  "Lost": "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
  "Cancelled": "bg-rose-50 text-rose-700 ring-1 ring-rose-200",
  // Job extras
  "New Request": "bg-sky-50 text-sky-700 ring-1 ring-sky-200",
  "Cleaner Assigned": "bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200",
  "In Progress": "bg-amber-50 text-amber-800 ring-1 ring-amber-200",
  "Completed": "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
  "Payment Pending": "bg-rose-50 text-rose-700 ring-1 ring-rose-200",
  "Complaint / Re-clean": "bg-red-50 text-red-700 ring-1 ring-red-200",
  "Follow-Up Needed": "bg-yellow-50 text-yellow-800 ring-1 ring-yellow-200",
  // Payment
  "Not Sent": "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
  "Invoice Sent": "bg-blue-50 text-blue-700 ring-1 ring-blue-200",
  "Deposit Paid": "bg-cyan-50 text-cyan-800 ring-1 ring-cyan-200",
  "Paid": "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
  "Partially Paid": "bg-amber-50 text-amber-800 ring-1 ring-amber-200",
  "Overdue": "bg-rose-50 text-rose-700 ring-1 ring-rose-200",
  "Refunded": "bg-purple-50 text-purple-700 ring-1 ring-purple-200",
  // Complaint
  "New Complaint": "bg-red-50 text-red-700 ring-1 ring-red-200",
  "Under Review": "bg-amber-50 text-amber-800 ring-1 ring-amber-200",
  "Re-clean Offered": "bg-violet-50 text-violet-700 ring-1 ring-violet-200",
  "Re-clean Scheduled": "bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200",
  "Resolved": "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
  "Closed": "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
};

export default function StatusBadge({ status, className = "", testid }) {
  if (!status) return null;
  const klass = COLORS[status] || "bg-slate-100 text-slate-700 ring-1 ring-slate-200";
  return (
    <span data-testid={testid || `status-${status}`} className={`pill ${klass} ${className}`}>
      {status}
    </span>
  );
}
